<template>
  <div class="exercises-lib-container">
    <div class="exercises-lib-search">
      <h3 class="sidebar-title">Buscar ejercicio</h3>
      <b-form-input
        v-model="searchInput"
        @input="changedInput"
        class="nft-search-box"
        type="text"
        placeholder="Buscar..."
      />
    </div>
    <div class="exercises-lib-content">
      <SpinnerBackdrop v-if="searching" size="4rem" thickness="0.4rem" variant="info" />
      <template>
        <draggable
          v-model="results"
          chosenClass="drag-chosen"
          ghostClass="drag-ghost"
          :sort="false"
          :clone="clone"
          :group="{name: 'routine', pull: 'clone', put: false}"
        >
          <b-card v-for="exercise in results" class="exercise-card" :key="exercise.id">
            <span>{{exercise.type.name}}</span>
          </b-card>
        </draggable>
      </template>
    </div>
  </div>
</template>

<script>
import { keyMixin } from "../../../mixins/keyMixin";
import draggable from "vuedraggable";
import patientService from "../../../services/patientService";
import SpinnerBackdrop from "../../SpinnerBackdrop";

export default {
  name: "ExercisesLibrary",
  components: { SpinnerBackdrop, draggable },
  mixins: [keyMixin],
  data: function() {
    return {
      searchInput: "",
      searchTimeout: null,
      searching: false,
      results: []
    };
  },
  mounted() {
    this.doSearch("");
  },
  methods: {
    changedInput: function(inputText) {
      this.searchInput = inputText.trim();
      if (this.searchInput.length >= 3 || this.searchInput=="") {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => this.doSearch(this.searchInput), 300);
      }
    },
    clone: function(el) {
      return Object.assign(Object.assign({}, el), { id: this.random_key() });
    },
    doSearch: function(searchText) {
      this.searching = true;
      this.results = [];
      patientService.get_excercises_by_tag_name({ search: searchText }).then(
        data => {
          this.searching = false;
          this.results = data.exercise_types;
        },
        // eslint-disable-next-line
        error => {
          this.searching = false;
          this.results = [];
          this.$toasted.error("Ha ocurrido un error buscando");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.exercises-lib-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  & .exercises-lib-search {
    flex-grow: 0;
    padding-bottom: map_get($spacers, 4);
  }

  & .exercises-lib-content {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 8px;
  }
}

.nft-search-box {
  margin-top: $spacer;
}

.exercise-card {
  margin: map_get($spacers, 2) 0;
  text-align: center;
  transition-property: box-shadow, background-color;
  transition-duration: 0.15s;
  cursor: move;

  &:hover {
    background-color: $hover-background-color;
  }

  & .card-body {
    padding: 8px;
  }
}

.drag-chosen {
  z-index: $zindex-tooltip;
  cursor: move;
  background-color: rgba(theme-color("primary"), 0.05);
  box-shadow: 1px 1px 4px 0 rgba(theme-color-level("primary", 10), 0.5);
}
</style>